import React, { useEffect } from "react";
import BreadCrumb from "Common/BreadCrumb";

// Images
import avatar4 from "assets/images/users/avatar-4.png";

import delivery1 from "assets/images/brand/delivery-1.png";

import productImg01 from "assets/images/product/img-01.png";
import productImg04 from "assets/images/product/img-04.png";
import productImg08 from "assets/images/product/img-08.png";

// icons
import { Truck, CreditCard, CircleDollarSign, Download } from "lucide-react";
import { Link, useParams } from "react-router-dom";
import { formateDate } from "utils/date";
import OrderOverviewCard from "../OrderOverviewCard";
import { useSelector } from "react-redux";
import { getCategories } from "slices/thunk";
import { useDispatch } from "react-redux";
import { getOrderById as onGetOrderById } from "slices/thunk";

const OrderOverview = () => {
  const dispatch = useDispatch<any>();
  const { id } = useParams();

  const { categories } = useSelector((state: any) => state.Jewellery);
  const { orderDetail } = useSelector((state: any) => state.Order);

  const category = categories.find(
    (category: any) => category?._id === orderDetail?.product?.category
  );

  useEffect(() => {
    dispatch(getCategories());
  }, [dispatch]);

  useEffect(() => {
    if (id) {
      dispatch(onGetOrderById(id));
    }
  }, [id]);

  const Status = ({ status }: any) => {
    switch (status) {
      case "delivered":
        return (
          <div className="text-center">
            <span className="delivery_status px-2.5 py-0.5 text-xs inline-block font-medium rounded border bg-green-100 border-green-200 text-green-500 dark:bg-green-500/20 dark:border-green-500/20">
              {status}
            </span>
            <p className="uppercase mt-1 text-slate-500 dark:text-zink-200">
              Order Status
            </p>
          </div>
        );
      case "shipping":
        return (
          <div className="text-center">
            <span className="delivery_status px-2.5 py-0.5 text-xs inline-block font-medium rounded border bg-purple-100 border-purple-200 text-purple-500 dark:bg-purple-500/20 dark:border-purple-500/20">
              {status}
            </span>
            <p className="uppercase mt-1 text-slate-500 dark:text-zink-200">
              Order Status
            </p>
          </div>
        );
      case "new":
        return (
          <div className="text-center">
            <span className="delivery_status px-2.5 py-0.5 text-xs inline-block font-medium rounded border bg-sky-100 border-sky-200 text-sky-500 dark:bg-sky-500/20 dark:border-sky-500/20">
              {status}
            </span>
            <p className="uppercase mt-1 text-slate-500 dark:text-zink-200">
              Order Status
            </p>
          </div>
        );
      case "pending":
        return (
          <div className="text-center">
            <span className="delivery_status px-2.5 py-0.5 text-xs inline-block font-medium rounded border bg-yellow-100 border-yellow-200 text-yellow-500 dark:bg-yellow-500/20 dark:border-yellow-500/20">
              {status}
            </span>
            <p className="uppercase mt-1 text-slate-500 dark:text-zink-200">
              Order Status
            </p>
          </div>
        );
      case "cancelled":
        return (
          <div className="text-center">
            <span className="delivery_status px-2.5 py-0.5 text-xs inline-block font-medium rounded border bg-red-100 border-red-200 text-red-500 dark:bg-red-500/20 dark:border-red-500/20">
              {status}
            </span>
            <p className="uppercase mt-1 text-slate-500 dark:text-zink-200">
              Order Status
            </p>
          </div>
        );
      case "return":
        return (
          <div className="text-center">
            <span className="delivery_status px-2.5 py-0.5 text-xs inline-block font-medium rounded border bg-slate-100 border-slate-200 text-slate-500 dark:bg-slate-500/20 dark:border-slate-500/20 dark:text-zink-200">
              {status}
            </span>
            <p className="uppercase mt-1 text-slate-500 dark:text-zink-200">
              Order Status
            </p>
          </div>
        );
      default:
        return (
          <span className="capitalize delivery_status px-2.5 py-0.5 text-xs inline-block font-medium rounded border bg-green-100 border-green-200 text-green-500 dark:bg-green-500/20 dark:border-green-500/20">
            {status}
          </span>
        );
    }
  };

  return (
    <React.Fragment>
      <BreadCrumb title="Order Overview" pageTitle="Jewellery" />
      <div className="grid grid-cols-1 2xl:grid-cols-12 gap-x-5">
        <div className="2xl:col-span-3">
          {/* <div className="card">
            <div className="card-body">
              <div className="flex items-center justify-center size-12 bg-purple-100 rounded-md dark:bg-purple-500/20 ltr:float-right rtl:float-left">
                <Truck className="text-purple-500 fill-purple-200 dark:fill-purple-500/30" />
              </div>
              <h6 className="mb-4 text-15">Shipping Details</h6>

              <h6 className="mb-1">
                {orderDetail?.shippingAddress?.firstName}{" "}
                {orderDetail?.shippingAddress?.lastName}
              </h6>
              <p className="mb-1 text-slate-500 dark:text-zink-200">
                {orderDetail?.shippingAddress?.streetAddress}
              </p>
              <p className="text-slate-500 dark:text-zink-200">
                {orderDetail?.shippingAddress?.city},{" "}
                {orderDetail?.shippingAddress?.country}
              </p>
            </div>
          </div> */}
          <OrderOverviewCard
            icon={
              <div className="flex items-center justify-center size-12 bg-purple-100 rounded-md dark:bg-purple-500/20">
                <Truck className="text-purple-500 fill-purple-200 dark:fill-purple-500/30" />
              </div>
            }
            header="Shipping Details"
          >
            <h6 className="mb-1">
              {orderDetail?.shippingAddress?.firstName}{" "}
              {orderDetail?.shippingAddress?.lastName}
            </h6>
            <p className="mb-1 text-slate-500 dark:text-zink-200">
              {orderDetail?.shippingAddress?.streetAddress}
            </p>
            <p className="text-slate-500 dark:text-zink-200">
              {orderDetail?.shippingAddress?.city},{" "}
              {orderDetail?.shippingAddress?.country}
            </p>
          </OrderOverviewCard>
        </div>
        <div className="2xl:col-span-3">
          <OrderOverviewCard
            icon={
              <div className="flex items-center justify-center size-12 bg-orange-100 rounded-md dark:bg-orange-500/20 ltr:float-right rtl:float-left">
                <CreditCard className="text-orange-500 fill-orange-200 dark:fill-orange-500/30" />
              </div>
            }
            header="Billing Details"
          >
            <h6 className="mb-1">
              {orderDetail?.shippingAddress?.firstName}{" "}
              {orderDetail?.shippingAddress?.lastName}
            </h6>
            <p className="mb-1 text-slate-500 dark:text-zink-200">
              {orderDetail?.shippingAddress?.streetAddress}
            </p>
            <p className="text-slate-500 dark:text-zink-200">
              {orderDetail?.shippingAddress?.city},{" "}
              {orderDetail?.shippingAddress?.country}
            </p>
          </OrderOverviewCard>
        </div>
        <div className="2xl:col-span-3">
          <OrderOverviewCard
            icon={
              <div className="flex items-center justify-center size-12 rounded-md ltr:float-right rtl:float-left bg-sky-100 dark:bg-sky-500/20">
                <CircleDollarSign className="text-sky-500 fill-sky-200 dark:fill-sky-500/30" />
              </div>
            }
            header="Payment Details"
          >
            {/* <h6 className="mb-1">ID: #TSD456DF41SD5</h6> */}
            <p className="mb-1 text-slate-500 capitalize dark:text-zink-200">
              Payment Method: <b>{orderDetail?.paymentMethod}</b>
            </p>
            {/* <p className="mb-1 text-slate-500 dark:text-zink-200">
                Card Number: <b>xxxx xxxx xxxx 1501</b>
              </p> */}
          </OrderOverviewCard>
        </div>
        <div className="2xl:col-span-3">
          <OrderOverviewCard
            icon={
              <div className="size-12 bg-yellow-100 rounded-md ltr:float-right rtl:float-left dark:bg-yellow-500/20">
                <img
                  src={orderDetail?.user?.image}
                  alt=""
                  className="h-12 w-full rounded-md"
                />
              </div>
            }
            header="Customer Info"
          >
            <h6 className="mb-1">{orderDetail?.user?.name}</h6>
            <p className="mb-1 text-slate-500 dark:text-zink-200">
              {orderDetail?.user?.email}
            </p>
            <p className="text-slate-500 dark:text-zink-200">
              +{orderDetail?.user?.number}
            </p>
          </OrderOverviewCard>
        </div>
      </div>

      <div className="grid grid-cols-1 2xl:grid-cols-12 gap-x-5">
        <div className="2xl:col-span-9">
          <div className="grid grid-cols-1 2xl:grid-cols-5 gap-x-5">
            <div>
              <OrderOverviewCard>
                <div className="text-center">
                  <h6 className="mb-1 underline">{orderDetail?._id}</h6>
                  <p className="uppercase text-slate-500 dark:text-zink-200">
                    Order ID
                  </p>
                </div>
              </OrderOverviewCard>
            </div>
            <div>
              <OrderOverviewCard>
                <div className="text-center">
                  <h6 className="mb-1">
                    {formateDate(orderDetail?.orderDate)}
                  </h6>
                  <p className="uppercase text-slate-500 dark:text-zink-200">
                    Order Date
                  </p>
                </div>
              </OrderOverviewCard>
            </div>
            <div>
              <OrderOverviewCard>
                <div className="text-center">
                  <h6 className="mb-1">
                    {formateDate(orderDetail?.deliveryDate)}
                  </h6>
                  <p className="uppercase text-slate-500 dark:text-zink-200">
                    Delivery Date
                  </p>
                </div>
              </OrderOverviewCard>
            </div>
            <div>
              <OrderOverviewCard>
                <div className="text-center">
                  <h6 className="mb-1">${orderDetail?.amount}</h6>
                  <p className="uppercase text-slate-500 dark:text-zink-200">
                    Order Amount
                  </p>
                </div>
              </OrderOverviewCard>
            </div>
            <div>
              <OrderOverviewCard>
                {/* <div className="text-center">
                  <span className="delivery_status px-2.5 py-0.5 text-xs inline-block font-medium rounded border bg-purple-100 border-purple-200 text-purple-500 dark:bg-purple-500/20 dark:border-purple-500/20">
                    {orderDetail?.status}
                  </span>
                  <p className="uppercase mt-1 text-slate-500 dark:text-zink-200">
                    Order Status
                  </p>
                </div> */}
                <Status status={orderDetail?.status} />
              </OrderOverviewCard>
            </div>
          </div>
          <OrderOverviewCard>
            <div className="">
              <div className="flex items-center gap-3 mb-4">
                <h6 className="text-15 grow">Order Summary</h6>
                <Link to="#!" className="text-red-500 underline shrink-0">
                  Cancel Order
                </Link>
              </div>
              <div className="overflow-x-auto">
                <table className="w-full">
                  <tbody>
                    <tr>
                      <td className="px-3.5 py-4 border-b w-full border-dashed first:pl-0 last:pr-0 border-slate-200 dark:border-zink-500">
                        <div className="flex items-center gap-3">
                          <div className="flex items-center justify-center size-12 rounded-md bg-slate-100 shrink-0">
                            <img
                              src={orderDetail?.product?.image}
                              alt=""
                              className="h-auto w-full"
                            />
                          </div>
                          <div className="grow">
                            <h6 className="mb-1 text-15">
                              <Link
                                to="/apps-ecommerce-product-overview"
                                className="transition-all duration-300 ease-linear hover:text-custom-500"
                              >
                                {orderDetail?.product?.title}
                              </Link>
                            </h6>
                            <p className="text-slate-500 dark:text-zink-200">
                              {orderDetail?.product?.sku}
                            </p>
                          </div>
                        </div>
                      </td>
                      {/* <td className="px-3.5 py-4 border-b border-dashed first:pl-0 last:pr-0 border-slate-200 dark:border-zink-500 ltr:text-right rtl:text-left">
                        $299.98
                      </td> */}
                    </tr>
                    {/* <tr>
                      <td className="px-3.5 py-4 border-b border-dashed first:pl-0 last:pr-0 border-slate-200 dark:border-zink-500">
                        <div className="flex items-center gap-3">
                          <div className="flex items-center justify-center size-12 rounded-md bg-slate-100 shrink-0">
                            <img src={productImg04} alt="" className="h-8" />
                          </div>
                          <div className="grow">
                            <h6 className="mb-1 text-15">
                              <Link
                                to="/apps-ecommerce-product-overview"
                                className="transition-all duration-300 ease-linear hover:text-custom-500"
                              >
                                Mesh Ergonomic Green Chair
                              </Link>
                            </h6>
                            <p className="text-slate-500 dark:text-zink-200">
                              $362.21 x 1
                            </p>
                          </div>
                        </div>
                      </td>
                      <td className="px-3.5 py-4 border-b border-dashed first:pl-0 last:pr-0 border-slate-200 dark:border-zink-500 ltr:text-right rtl:text-left">
                        $362.21
                      </td>
                    </tr>
                    <tr>
                      <td className="px-3.5 py-4 border-b border-dashed first:pl-0 last:pr-0 border-slate-200 dark:border-zink-500">
                        <div className="flex items-center gap-3">
                          <div className="flex items-center justify-center size-12 rounded-md bg-slate-100 shrink-0">
                            <img src={productImg01} alt="" className="h-8" />
                          </div>
                          <div className="grow">
                            <h6 className="mb-1 text-15">
                              <Link
                                to="/apps-ecommerce-product-overview"
                                className="transition-all duration-300 ease-linear hover:text-custom-500"
                              >
                                Smartest Printed T-shirt
                              </Link>
                            </h6>
                            <p className="text-slate-500 dark:text-zink-200">
                              $89.99 x 03
                            </p>
                          </div>
                        </div>
                      </td>
                      <td className="px-3.5 py-4 border-b border-dashed first:pl-0 last:pr-0 border-slate-200 dark:border-zink-500 ltr:text-right rtl:text-left">
                        $269.97
                      </td>
                    </tr> */}
                    <tr>
                      <td className="px-3.5 pt-4 pb-3 first:pl-0 last:pr-0 text-slate-500 dark:text-zink-200">
                        Sub Total
                      </td>
                      <td className="px-3.5 pt-4 pb-3 first:pl-0 last:pr-0 ltr:text-right rtl:text-left">
                        ${orderDetail?.amountBreakdown?.subtotal}
                      </td>
                    </tr>
                    <tr>
                      <td className="px-3.5 py-3 first:pl-0 last:pr-0 text-slate-500 dark:text-zink-200">
                        Estimated Tax ({orderDetail?.amountBreakdown?.taxRate}%)
                      </td>
                      <td className="px-3.5 py-3 first:pl-0 last:pr-0 ltr:text-right rtl:text-left">
                        ${orderDetail?.amountBreakdown?.taxAmount}
                      </td>
                    </tr>
                    <tr>
                      <td className="px-3.5 py-3 first:pl-0 last:pr-0 text-slate-500 dark:text-zink-200">
                        Item Discount
                      </td>
                      <td className="px-3.5 py-3 first:pl-0 last:pr-0 ltr:text-right rtl:text-left">
                        -${orderDetail?.amountBreakdown?.discountAmount}
                      </td>
                    </tr>
                    <tr>
                      <td className="px-3.5 py-3 first:pl-0 last:pr-0 text-slate-500 dark:text-zink-200">
                        Shipping Charge
                      </td>
                      <td className="px-3.5 py-3 first:pl-0 last:pr-0 ltr:text-right rtl:text-left">
                        $0
                      </td>
                    </tr>
                    <tr className="font-semibold">
                      <td className="px-3.5 pt-3 first:pl-0 last:pr-0 text-slate-500 dark:text-zink-200">
                        Total Amount (USD)
                      </td>
                      <td className="px-3.5 pt-3 first:pl-0 last:pr-0 ltr:text-right rtl:text-left">
                        ${orderDetail?.amountBreakdown?.total}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </OrderOverviewCard>

          <OrderOverviewCard>
            <div className="">
              <div className="flex items-center gap-3 mb-4">
                <h6 className="text-15 grow">Order Status</h6>
                <div className="shrink-0">
                  <Link
                    to="#!"
                    className="inline-block text-red-500 underline ltr:mr-2 rtl:ml-2"
                  >
                    Cancel Order
                  </Link>
                </div>
              </div>
              <div>
                <div className="relative ltr:pl-6 rtl:pr-6 before:absolute ltr:before:border-l rtl:before:border-r ltr:before:left-[0.1875rem] rtl:before:right-[0.1875rem] before:border-slate-200 [&.done]:before:border-custom-500 before:top-1.5 before:-bottom-1.5 after:absolute after:size-2 after:bg-white after:border after:border-slate-200 after:rounded-full ltr:after:left-0 rtl:after:right-0 after:top-1.5 pb-4 last:before:hidden [&.done]:after:bg-custom-500 [&.done]:after:border-custom-500 done">
                  <div className="flex gap-4">
                    <div className="grow">
                      <h6 className="mb-2 text-gray-800 text-15 dark:text-zink-50">
                        Order Placed
                      </h6>
                      <p className="text-gray-400 dark:text-zink-200">
                        Your order has been successfully submitted.
                      </p>
                    </div>
                    <p className="text-sm text-gray-400 dark:text-zink-200 shrink-0">
                      02 Nov, 2023
                    </p>
                  </div>
                </div>
                <div className="relative ltr:pl-6 rtl:pr-6 before:absolute ltr:before:border-l rtl:before:border-r ltr:before:left-[0.1875rem] rtl:before:right-[0.1875rem] before:border-slate-200 [&.done]:before:border-custom-500 before:top-1.5 before:-bottom-1.5 after:absolute after:size-2 after:bg-white after:border after:border-slate-200 after:rounded-full ltr:after:left-0 rtl:after:right-0 after:top-1.5 pb-4 last:before:hidden [&.done]:after:bg-custom-500 [&.done]:after:border-custom-500 done">
                  <div className="flex gap-4">
                    <div className="grow">
                      <h6 className="mb-2 text-gray-800 text-15 dark:text-zink-50">
                        Order Processing
                      </h6>
                      <p className="text-gray-400 dark:text-zink-200">
                        Once the order is received, it goes through the
                        processing stage. During this time, the items are
                        gathered, and the order is prepared for shipment.
                      </p>
                    </div>
                    <p className="text-sm text-gray-400 dark:text-zink-200 shrink-0">
                      02 Nov, 2023
                    </p>
                  </div>
                </div>
                <div className="relative ltr:pl-6 rtl:pr-6 before:absolute ltr:before:border-l rtl:before:border-r ltr:before:left-[0.1875rem] rtl:before:right-[0.1875rem] before:border-slate-200 [&.done]:before:border-custom-500 before:top-1.5 before:-bottom-1.5 after:absolute after:size-2 after:bg-white after:border after:border-slate-200 after:rounded-full ltr:after:left-0 rtl:after:right-0 after:top-1.5 pb-4 last:before:hidden [&.done]:after:bg-custom-500 [&.done]:after:border-custom-500 done">
                  <div className="flex gap-4">
                    <div className="grow">
                      <h6 className="mb-2 text-gray-800 text-15 dark:text-zink-50">
                        Shipped Order
                      </h6>
                      <p className="text-gray-400 dark:text-zink-200">
                        The order is shipped out to the customer's designated
                        delivery address.
                      </p>
                    </div>
                    <p className="text-sm text-gray-400 dark:text-zink-200 shrink-0">
                      04 Nov, 2023
                    </p>
                  </div>
                </div>
                <div className="relative ltr:pl-6 rtl:pr-6 before:absolute ltr:before:border-l rtl:before:border-r ltr:before:left-[0.1875rem] rtl:before:right-[0.1875rem] before:border-slate-200 [&.done]:before:border-custom-500 before:top-1.5 before:-bottom-1.5 after:absolute after:size-2 after:bg-white after:border after:border-slate-200 after:rounded-full ltr:after:left-0 rtl:after:right-0 after:top-1.5 pb-4 last:before:hidden [&.done]:after:bg-custom-500 [&.done]:after:border-custom-500 done">
                  <div className="flex gap-4">
                    <div className="grow">
                      <h6 className="mb-2 text-gray-800 text-15 dark:text-zink-50">
                        Out for Delivery
                      </h6>
                      <p className="text-gray-400 dark:text-zink-200">
                        This status indicates that the order is currently out
                        for delivery by the shipping or courier company.
                      </p>
                    </div>
                    <p className="text-sm text-gray-400 dark:text-zink-200 shrink-0">
                      06 Nov, 2023
                    </p>
                  </div>
                </div>
                <div className="relative ltr:pl-6 rtl:pr-6 before:absolute ltr:before:border-l rtl:before:border-r ltr:before:left-[0.1875rem] rtl:before:right-[0.1875rem] before:border-slate-200 [&.done]:before:border-custom-500 before:top-1.5 before:-bottom-1.5 after:absolute after:size-2 after:bg-white after:border after:border-slate-200 after:rounded-full ltr:after:left-0 rtl:after:right-0 after:top-1.5 pb-4 last:before:hidden [&.done]:after:bg-custom-500 [&.done]:after:border-custom-500 done">
                  <div className="flex gap-4">
                    <div className="grow">
                      <h6 className="mb-2 text-gray-800 text-15 dark:text-zink-50">
                        Delivered
                      </h6>
                      <p className="text-gray-400 dark:text-zink-200">
                        Finally, when the order successfully reaches the
                        customer's address and is handed over, the status
                        changes to "Delivered."
                      </p>
                    </div>
                    <p className="text-sm text-gray-400 dark:text-zink-200 shrink-0">
                      09 Nov, 2023
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </OrderOverviewCard>
        </div>
        <div className="2xl:col-span-3">
          <OrderOverviewCard header="Document">
            <div className="flex justify-center">Comming soon...</div>
          </OrderOverviewCard>
          <OrderOverviewCard header="Product Details">
            <div className="">
              <b>Metal:</b> {orderDetail?.configuration?.metal?.carateType}{" "}
              {orderDetail?.configuration?.metal?.type}
            </div>
            <div className="">
              <b>Diamond Shape:</b> {orderDetail?.configuration?.diamond?.shape}{" "}
            </div>
            <div className="">
              <b>Diamond Carat:</b> {orderDetail?.configuration?.diamond?.carat}
            </div>
            {category?.showRingSize && (
              <div>
                <b>Ring Size:</b> {orderDetail?.configuration?.ringSize}
              </div>
            )}
            {category?.showBraceletLength && (
              <div>
                <b>Bracelet Length:</b>{" "}
                {orderDetail?.configuration?.braceletLength}
              </div>
            )}
          </OrderOverviewCard>
          <OrderOverviewCard header="Logistics Details">
            <div className="flex justify-center">Comming soon...</div>
          </OrderOverviewCard>
        </div>
      </div>
    </React.Fragment>
  );
};

export default OrderOverview;
